<template>
  <div class="root">
    <div class="title bg-purple">送货情况</div>
    <el-form class="form" size="mini" label-position="left" label-width="100px">
      <el-form-item label="通知时间">{{send.sendTime}}</el-form-item>
      <el-form-item label="送货时间">{{send.departureOperateTime}}</el-form-item>
      <el-form-item label="司机名称">{{send.driverOneName}}</el-form-item>
      <el-form-item label="司机电话">{{send.driverOnePhone}}</el-form-item>
      <el-form-item label="车牌号码">{{send.carNum}}</el-form-item>
      <el-form-item label="送货理货员">{{send.sendWorkers}}</el-form-item>
      <el-form-item label="随车搬运">{{send.carWorkers}}</el-form-item>
      <el-form-item label="经办人">{{send.createUserName}}</el-form-item>
      <el-form-item label="送货备注">{{send.remarks}}</el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    waybillSplitId: {},
  },
  data() {
    return {
      send: {
        sendTime: "",
        departureOperateTime: "",
        driverOneName: "",
        driverOnePhone: "",
        carNum: "",
        sendWorkers: "",
        carWorkers: "",
        createUserName:'',
        remarks: "",
      },
    };
  },
  watch: {
    waybillSplitId(val) {
      if (!val) {
        return;
      }
      this.getData();
    },
  },
  mounted(){
    this.getData()
  },
  methods: {
    async getData() {
      if(!this.waybillSplitId){
                return
      }
      const res = await this.$API.runDetail({
        number: "admin_waybill_sum_all_send_info_v5",
        waybillSplitId: this.waybillSplitId,
      });
      this.send = res;
    },
  },
};
</script>

<style lang="less" scoped>
.root {
  width: 100%;
  height: 100%;
  .title {
    display: flex;
    justify-content: center;
    height: 35px;
    line-height: 35px;
  }
  .el-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>